import styled from 'styled-components';
import { Button, Col, Row } from 'antd';

import { ModalStyled } from '@/views/Bera/_components/styles';

export const ModalLarge = styled(ModalStyled)`
	.ant-modal-content {
		padding: 2.5rem;
	}

	.ant-modal-close {
		top: 2.5rem;
		right: 2.5rem;
	}
`;

export const HeaderRow = styled(Row)`
	margin: 1.625rem 0 1rem;
`;

export const HeaderLabel = styled.span`
	display: block;
	text-align: center;
	color: ${({ theme }) => theme.palette.secondary[400]};
	font-size: 1rem;
	font-weight: 600;
	line-height: 1.5rem;
`;

interface VersionRowProps {
	$current: boolean;
}

export const VersionRow = styled(Row)<VersionRowProps>`
	margin-bottom: 0.5rem;
	border: 0.0625rem solid
		${({ theme, $current }) => ($current ? theme.palette.primary.default : theme.palette.secondary[150])};
	border-radius: 0.5rem;

	&:last-child {
		margin-bottom: 0;
	}
`;

export const Cell = styled(Col)`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 3rem;
	padding: 0 1rem;

	&::before {
		content: '';
		position: absolute;
		left: 0;
		width: 0.0625rem;
		height: 1.25rem;
		background: ${({ theme }) => theme.palette.secondary[100]};
	}

	&:first-child::before {
		display: none;
	}
`;

export const VersionName = styled.span`
	color: ${({ theme }) => theme.palette.secondary[400]};
	font-size: 0.875rem;
	font-weight: 600;
	line-height: 1rem;
`;

export const VersionDate = styled.span`
	color: ${({ theme }) => theme.palette.secondary[400]};
	font-size: 0.875rem;
	font-weight: 400;
	line-height: 1rem;
`;

export const TlidLink = styled(Button)`
	height: auto;
	padding: 0;
	color: ${({ theme }) => theme.palette.primary.default};
	font-size: 1rem;
	line-height: 1.5rem;
	text-decoration: underline;

	&:hover,
	&:focus {
		color: ${({ theme }) => theme.palette.primary[600]};
		text-decoration: underline;
	}
`;

export const ActionsCell = styled(Cell)`
	justify-content: flex-end;
	gap: 0;
`;

export const DownloadButton = styled(Button)`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 2.5rem;
	height: 2.5rem;
	padding: 0;
	color: ${({ theme }) => theme.palette.primary[600]};
`;

export const DangerButton = styled(DownloadButton)`
	color: ${({ theme }) => theme.colors.danger};

	&:hover,
	&:focus {
		color: ${({ theme }) => theme.colors.danger};
		opacity: 0.7;
	}
`;
